import { useTranslation } from "react-i18next";
import { useUser } from "../../context/UserContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import "./styles.css";

function replaceLngCounrtyPair(url, newPair) {
  return url
    .replace("de-de", newPair.toLowerCase())
    .replace("en-de", newPair.toLowerCase());
}

export const ProductCards = ({ products, layout }) => {
  const { t, i18n } = useTranslation("recommendation");
  const { uid, regionName } = useUser();
  const trackEvent = useAmplitude();

  // track product click event
  const trackProductClick = (productTitle, productUrl) => {
    trackEvent(
      "webapp_user_clicked_product",
      uid,
      "",
      "",
      productTitle,
      productUrl,
    );
  };

  return (
    <div className={`product-cards_${layout}`}>
      {products.map((product, index) => (
        <div
          key={index}
          className={`product-card_${layout}`}
          onClick={() => {
            if (product.url) {
              const shopCodedLink = replaceLngCounrtyPair(
                product.url,
                `${i18n.language}-${regionName}`,
              );
              trackProductClick(product.title, shopCodedLink);
              const newWindow = window.open(
                shopCodedLink,
                "_blank",
                "noopener,noreferrer",
              );
              if (newWindow) newWindow.opener = null;
            }
          }}
        >
          <div className={`product-img-container_${layout}`}>
            <img
              src={
                product.image
                  ? `data:image/png;base64, ${product.image}`
                  : "placeholder.png"
              }
              alt={product.title}
              className={`${!product.image ? "placeholder" : `product-img_${layout}`}`}
            />
          </div>
          <h4 className="product-brand">
            {product.brand === "" ? "\u00A0" : product.brand}
          </h4>
          {product.title && <h4 className="product-title">{product.title}</h4>}

          {/* product details */}
          {/* {layout !== "grid" && product.detail && (
              <p className="product-details">{product.detail}</p>
            )} */}

          <div className="product-assets">
            {product.url && (
              <h4 className="product-link">{t("product-details")}</h4>
            )}

            {product.price && (
              <h4 className="product-price">{product.price}</h4>
            )}

            {/* product size */}
            {/* {product.size && <h4 className="product-price">{product.size}</h4>} */}
          </div>
        </div>
      ))}
    </div>
  );
};
